module.exports = __webpack_public_path__ + "img/reverse.58cf878d.jpg";